import React from "react";
import PropTypes from "prop-types";
import PureSticky from "./PureSticky";

function StickyWithOffset(props) {
    let { render, topOffset } = props;

    return (
        <PureSticky
            topOffset={-Math.abs(topOffset)}
            bottomOffset={Math.abs(topOffset)}
            render={({ style, isSticky, ref }) => {
                const top =
                    topOffset && isSticky ? `${Math.abs(topOffset) - Math.abs(parseFloat(style.top))}px` : style.top;
                return render({
                    ref,
                    isSticky,
                    style: {
                        ...style,
                        top,
                    },
                });
            }}
        />
    );
}

StickyWithOffset.propTypes = {
    render: PropTypes.func.isRequired,
};

StickyWithOffset.defaultProps = {
    topOffset: 0,
    render: ({ style }) => <div style={style} />,
};

export default StickyWithOffset;
